const MuiFormLabel = {
  asterisk: {
    color: '#EA0000',
  },
}

export default MuiFormLabel
